import { IVisionDetectModel } from './IVisionDetectModel';
import { IVisionDetectResponse } from './IVisionDetectResponse';
import { rootApi } from '../../../../../services/rootApi';

const visionApi = rootApi.injectEndpoints({
    overrideExisting: false,

    endpoints: (builder) => ({
        detect: builder.mutation<IVisionDetectResponse, IVisionDetectModel>({
            query: (model) => ({
                url: '/AIVision/detect',
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: model
            })
        })
    })
})

export const { useDetectMutation } = visionApi;
